import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidenavService } from '../../services/sidenav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModuleService } from '../../../core/services/module.service';
import { Modules } from '../../utils/logistique-pn';
import { AuthorityService } from '../../../core/services/authority.service';
import { Scopes } from '../../../core/const/scopes';
import { MatMenuItem } from '@angular/material/menu';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
  imports: [MatMenuItem, NgClass, MatIcon, MatBadge, TranslocoPipe],
})
export class SidenavComponent implements OnInit, OnDestroy, AfterViewInit {
  selectedMenuItem: string | null = 'home';
  isSidenavOpen: boolean = true;
  private readonly sidenavSubscription: Subscription;

  hasPeqScope: boolean = false;
  hasMealCompensationScope: boolean = false;
  hasTaxisScope: boolean = false;
  hasPickupsHotelScope: boolean = false;
  hasCarRentalScope: boolean = false;
  hasShuttlesScope: boolean = false;
  hasParametersScope: boolean = false;
  hasLogisticPointsScope: boolean = false;

  constructor(
    private readonly sidenavService: SidenavService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    protected moduleService: ModuleService,
    protected authorityService: AuthorityService,
  ) {
    const currentUrl = this.router.url;
    const segments = currentUrl.split('/');
    if (segments.length > 1) {
      this.selectedMenuItem = segments[1];
    }
    this.sidenavSubscription = this.sidenavService.isSidenavOpen$.subscribe((isOpen) => {
      this.isSidenavOpen = isOpen;
    });
  }

  ngAfterViewInit() {
    this.sidenavService.setSidenavOpen(this.isSidenavOpen);
  }

  ngOnInit() {
    const currentUrl = this.router.url;
    const segments = currentUrl.split('/');
    if (segments.length > 1) {
      this.selectedMenuItem = segments[1];
    }
    this.checkScopes();
  }

  ngOnDestroy() {
    this.sidenavSubscription.unsubscribe();
  }

  selectMenuItem(menuItem: string) {
    this.selectedMenuItem = menuItem;
    this.router.navigate([menuItem], { relativeTo: this.route.parent });
  }

  protected readonly Modules = Modules;
  protected readonly Scopes = Scopes;

  async checkScopes(): Promise<void> {
    this.hasPeqScope = await this.authorityService.hasScopes([Scopes.PEQ_WRITE, Scopes.PEQ_READ]);
    this.hasMealCompensationScope = await this.authorityService.hasScopes([
      Scopes.MEAL_COMPENSATION_READ,
      Scopes.MEAL_COMPENSATION_WRITE,
    ]);
    this.hasTaxisScope = await this.authorityService.hasScopes([
      Scopes.TAXIS_WRITE,
      Scopes.TAXIS_READ,
    ]);
    this.hasCarRentalScope = await this.authorityService.hasScopes([
      Scopes.VOI_READ,
      Scopes.VOI_WRITE,
      Scopes.VDS_READ,
      Scopes.VDS_WRITE,
      Scopes.VDC_READ,
      Scopes.VDC_WRITE,
    ]);
    this.hasShuttlesScope = await this.authorityService.hasScopes([
      Scopes.SHUTTLES_WRITE,
      Scopes.SHUTTLES_READ,
    ]);
    this.hasPickupsHotelScope = await this.authorityService.hasScopes([
      Scopes.PICKUP_READ,
      Scopes.PICKUP_WRITE,
    ]);
    this.hasLogisticPointsScope = await this.authorityService.hasScopes([Scopes.POINTS_WRITE]);
    this.hasParametersScope = await this.authorityService.hasScopes([Scopes.PARAMETERS_WRITE]);
  }
}
